const model = {
    name: 'Pin',
    properties: {
        id: { required: true },
        slot: { type: 'array', required: true }, // TODO: Array of integers <int64>
    },
};
export default model;
